var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertPrimary = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.32803 0.400796C1.79363 -0.133599 0.929505 -0.133599 0.400796 0.400796C-0.127914 0.93519 -0.133599 1.79932 0.400796 2.32803L3.07277 5L0.400796 7.67197C-0.133599 8.20637 -0.133599 9.07049 0.400796 9.5992C0.93519 10.1279 1.79932 10.1336 2.32803 9.5992L5 6.92723L7.67197 9.5992C8.20637 10.1336 9.07049 10.1336 9.5992 9.5992C10.1279 9.06481 10.1336 8.20068 9.5992 7.67197L6.92723 5L9.5992 2.32803C10.1336 1.79363 10.1336 0.929505 9.5992 0.400796C9.06481 -0.127914 8.20068 -0.133599 7.67197 0.400796L5 3.07277L2.32803 0.400796Z",
  fill: "#F8F9FA"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertPrimary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "d0dafaf82646dd33e8b4bf17bd4c1163.svg";